import { Navigate, useLocation } from "react-router-dom";
import { isJwtValid } from "./auth.jsx";
import React from "react";
import jwt_decode from "jwt-decode";
import { INVESTOR, PARTNER, POLICY_MASTER } from "../../utils/index.jsx";
import MobileOTP from "../../pages/Register/MobileOTP/MobileOTP.jsx";
import UnauthorizedPage from "../../pages/Helper/unauthorizedPage.jsx";

const Auth = ({ children, allow, redirectTo, permission }) => {
  const authToken = localStorage.getItem("token");
  const location = useLocation(); // Get the current location object
  let loading = false;

  if (authToken === null || authToken === "undefined") {
    return <MobileOTP isAuthenticated={true} />;
  }

  const decodedToken = jwt_decode(authToken);
  if (loading) {
    return <>Loading</>;
  } else {
    if (allow === "$unauthenticated") {
      if (isJwtValid(authToken)) {
        if (decodedToken.currentRole === POLICY_MASTER) {
          return <Navigate to="/phDashboard" />;
        } else if (decodedToken.currentRole === INVESTOR) {
          return <Navigate to="/investorDashboard" />;
        } else if (decodedToken.currentRole === PARTNER) {
          return <Navigate to="/partnerDashboard" />;
        } else {
          return children;
        }
      } else {
        localStorage.clear();
        return children;
      }
    } else if (allow === "$authenticated" && isJwtValid(authToken)) {
      if (
        permission === "all" ||
        permission === decodedToken.currentRole ||
        decodedToken.role === permission
      ) {
        return children;
      } else {
        return <UnauthorizedPage />;
      }
    } else {
      // Clear local storage and redirect to the original location
      localStorage.clear();
      return <Navigate to={redirectTo + location.search} />; // Preserve query params in the redirect
    }
  }
};

export default Auth;
